import { bindCallbacks, statusText } from 'scripts/infrastructure/backends/fake_backend_http/lib/common';

export default class RoleService {
  constructor(database, pubsub) {
    this._pubsub = pubsub;
    this.getDatabase = database;
  }

  handleFindRoles(attrs, callback, path, { orgId, query }) {
    let roles = [];
    const idsParam = query && query['f.ids'];
    if (idsParam) {
      const ids = idsParam
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);
      roles = this.findRoles(orgId, ids);
    }

    callback(null, {
      status: 200,
      statusText: statusText(200),
      response: roles,
    });
  }

  findRoles(orgId, roleIds) {
    if (!Array.isArray(roleIds) || !roleIds.length) return [];
    const set = new Set(roleIds);
    return this.getDatabase(orgId).roles.filter(r => set.has(r.id));
  }

  getRoutes() {
    return bindCallbacks(
      {
        '/api/v1/orgs/:orgId/roles': {
          GET: this.handleFindRoles,
        },
      },
      this
    );
  }
}
